<div class="upload-progress mt-2 bg-info-alpha-10">
  <div class="h-100 bg-info" [style.width]="progress + '%'"></div>
</div>
